import { take, takeEvery, takeLatest, put, call } from 'redux-saga/effects'
import Urls from '../../utils/urlStrings'
import { get } from '../../utils/api'
import { MICROSERVICES } from '../../utils/constants'
import service from '../../utils/service'
import _ from 'lodash'
import {
  GET_GS_REQUESTS_FAILURE,
  GET_ALL_STATES_SUCCESS,
  GET_ALL_STATES_REQUEST,
  GET_ALL_SYSTEMS_SUCCESS,
  GET_ALL_EVENTS_SUCCESS,
  GET_ALL_SYSTEMS_REQUEST,
  GET_ALL_EVENTS_REQUEST,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAILED,
  SIGNUP_USER,
  USER_SIGNIN_SUCCESS,
  USER_SIGNIN_FAILED,
  SIGNIN_USER,
  POST_FILE_REQUEST,
  GET_ALL_PROGRAMS_REQUEST,
  GET_ALL_PROGRAMS_SUCCESS,
  CREATE_PROGRAM_REQUEST,
  POST_FILE_SUCCESS,
  GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_REQUEST,
  GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_SUCCESS,
  DELETE_FILE_REQUEST,
  DELETE_FILE_SUCCESS,
  DOWNLOAD_FILE_REQUEST,
  DOWNLOAD_FILE_SUCCESS,
  GET_PROGRAM_BY_ID,
  GET_PROGRAM_BY_ID_SUCCESS,
  GET_PROGRAM_BY_ID_NOT_FOUND,
} from '../../Constants/ActionTypes'
import axios from 'axios'
import { setToken, setAccountId, getAccountId } from '../../utils/helper'

//watcher & worker function for get all programs action
export function* getProgramsFlow() {
  while (true) {
    const request = yield take(GET_ALL_PROGRAMS_REQUEST)
    const { successCb = () => { }, failureCb = () => { } } = request.payload
    try {
      let response
      response = yield call(get, {
        // url: Urls.getApiUrl(`admin/${getAccountId()}/programs/all`, MICROSERVICES.PROGRAMMANAGER)
        url: Urls.getApiUrl(
          `admin/${getAccountId()}/programs/all`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
      })
      const { success, status, result } = response
      const { data } = result
      if (success && status === 200) {
        yield put({
          type: GET_ALL_PROGRAMS_SUCCESS,
          programsList: data || [],
          message: '',
        })
      } else {
        yield put({
          type: GET_GS_REQUESTS_FAILURE,
          message: result.message || result.messages,
        })
      }
    } catch (error) {
      yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
    }
  }
}

//watcher & worker function for get all systems action

export function* getEventsFlow() {
  while (true) {
    const request = yield take(GET_ALL_EVENTS_REQUEST)
    const { successCb = () => { }, failureCb = () => { } } = request.payload
    try {
      let response
      response = yield call(get, {
        url: Urls.getApiUrl(
          `admin/${getAccountId()}/events/all`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
      })

      const { success, status, result } = response
      const { data } = result
      if (success && status === 200) {
        yield put({
          type: GET_ALL_EVENTS_SUCCESS,
          systemsList: data || [],
          message: '',
        })
      } else {
        yield put({
          type: GET_GS_REQUESTS_FAILURE,
          message: result.message || result.messages,
        })
      }
    } catch (error) {
      yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
    }
  }
}

//watcher & worker function for create program action

export function* createProgramsFlow() {
  while (true) {
    const request = yield take(CREATE_PROGRAM_REQUEST)
    const {
      successCb = () => { },
      failureCb = () => { },
      details,
    } = request.payload

    try {
      let response
      response = yield call(get, {
        url: Urls.getApiUrl(
          `admin/${getAccountId()}/programs/add`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
        // url: Urls.getApiUrl(`admin/*/programs/add`, MICROSERVICES.PROGRAMMANAGER)
      })

      const { success, status, result } = response
      const { data } = result
      if (success && status === 200) {
        // yield put({
        //   type: GET_ALL_PROGRAMS_SUCCESS,
        //   programsList: data || [],
        //   message: ''
        // })
      } else {
        yield put({
          type: GET_GS_REQUESTS_FAILURE,
          message: result.message || result.messages,
        })
      }
    } catch (error) {
      yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
    }
  }
}

//watcher & worker function for get all states action
const getAllUSAStates = async () =>
  await service
    .get(Urls.getApiUrl(
      `states/USA`,
      MICROSERVICES.PROGRAMMANAGER,
    ))
    .then((response) => response)
    .catch((error) => error)

export function* getAllStatesFlow() {
  while (true) {
    const request = yield take(GET_ALL_STATES_REQUEST)

    try {
      let response = yield call(getAllUSAStates)
      // response = yield call(get, {
      //   url: Urls.getApiUrl(
      //     `states/USA`,
      //     MICROSERVICES.PROGRAMMANAGER,
      //   ),
      //   // url: Urls.getApiUrl(`admin/${getAccountId()}/states/USA`, MICROSERVICES.PROGRAMMANAGER)
      //   // url: Urls.getApiUrl(
      //   //   `admin/${accountId}/states/USA`,
      //   //   MICROSERVICES.PROGRAMMANAGER,
      //   // )
      // })

      const { success, status, result, data } = response
      // const { data } = data
      if (status === 200) {
        yield put({
          type: GET_ALL_STATES_SUCCESS,
          states: data.data || [],
          message: '',
        })
      } else {
        yield put({
          type: GET_GS_REQUESTS_FAILURE,
          message: result.message || result.messages,
        })
      }
    } catch (error) {
      yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
    }
  }
}

//---------sign up saga flow------------

//server endpoint api execution function to post user sign up details for response from server
const signUpWithDetailsRequest = async (payload) =>
  await axios
    .post(
      'https://gs-dev.qa-enphaseenergy.com/session-mgr/api/v1/admin/signup/',
      { ...payload, country: 'US' },
    )
    .then((authUser) => authUser)
    .catch((error) => error)

//worker function for sign up of a user with user details - the reducer for action
function* signUpUserWithDetails({ payload }) {
  try {
    const response = yield call(signUpWithDetailsRequest, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({ type: USER_SIGNUP_SUCCESS })
    }
  } catch (error) {
    yield put({ type: USER_SIGNUP_FAILED })
  }
}

//watcher function for sign up of a user with user details action
export function* signUpWithDetails() {
  yield takeEvery(SIGNUP_USER, signUpUserWithDetails)
}

//--------sign in saga flow-------

//server endpoint api execution function to post user sign in details for response from server
const signInWithDetailsRequest = async (payload) =>
  await axios
    .post(
      'https://gs-dev.qa-enphaseenergy.com/session-mgr/api/v1/admin/signin/',
      payload,
    )
    .then((authUser) => authUser)
    .catch((error) => error)

//worker function for sign in of a user with user details - the reducer for action
function* signInUserWithDetails({ payload }) {
  try {
    const response = yield call(signInWithDetailsRequest, payload)
    const { status, data } = response
    if (status === 200) {
      setToken(data['GS-Authorization'])
      setAccountId(data['account_id'])
      yield put({ type: USER_SIGNIN_SUCCESS, payload: data })
    }
  } catch (error) {
    yield put({ type: USER_SIGNIN_FAILED })
  }
}

//watcher function for sign in of a user with user details action
export function* signInWithDetails() {
  yield takeEvery(SIGNIN_USER, signInUserWithDetails)
}

//gets called when watcher signals based on POST_FILE_REQUEST and makes loading as true
//calls the upload api from frontend with payload - check
//do an action based on POST_FILE_SUCCESS - to send a success message with uploaded = true
//do an action based on POST_FILE_FAILURE - to send an error message upload failed with uploaded = false

//as soon as program files component gets loaded do an api call to get programmetadata by program id and store the program metadata object in state
//maintain the status of different files ias per url presence of different files in metadata object
//on upload , delete or download do following update in program metadata object using its id and reflect same on frontend

//upload file to S3 | update the program object with generated link | return back the latest program object
//watcher
//do an action based on POST_FILE_REQUEST
export function* postProgramFilesWatcher() {
  yield takeEvery(POST_FILE_REQUEST, postProgramFilesWorker)
}

//worker
function* postProgramFilesWorker({ payload }) {
  try {
    const response = yield call(postProgramFilesRequest, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({
        type: POST_FILE_SUCCESS,
        programMetadata: data.data || null,
        message: '',
      })
    } else {
      yield put({
        type: GET_GS_REQUESTS_FAILURE,
        message: 'POST PROGRAM FILE REQUEST ERROR',
      })
    }
  } catch (error) {
    yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
  }
}
//server endpoint api execution function to post user sign in details for response from server
const postProgramFilesRequest = async (payload) => {
  var data = new FormData()
  data.append('file', _.get(payload, 'file', null))
  data.append('program_file_key', _.get(payload, 'program_file_key', null))
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  return await service
    .post(
      Urls.getApiUrl(
        `admin/${getAccountId()}/programenrollmentforms/${_.get(
          payload,
          'program_enrollment_form_metadata_id',
          '',
        )}/programfile/upload`,
        MICROSERVICES.PROGRAMMANAGER,
      ),
      data,
      config,
    )
    .then((data) => data)
    .catch((error) => error)
}

//watcher & worker function for get all systems action

export function* getSystemsFlow() {
  yield takeLatest(GET_ALL_SYSTEMS_REQUEST, getAllSystems)
}

function* getAllSystems({ payload }) {
  try {
    let response
    response = yield call(getAllSystemsWithFilter, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({
        type: GET_ALL_SYSTEMS_SUCCESS,
        systemsList: data.data || [],
        message: '',
      })
    } else {
      yield put({
        type: GET_GS_REQUESTS_FAILURE,
        message: 'GET ALL SYSTEMS BY FILTER ERROR',
      })
    }
  } catch (error) {
    yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
  }
}

//server endpoint api execution function to get all systems as response from server - PUT method
const getAllSystemsWithFilter = async ({
  programId,
  requestBody,
  pageNo,
  pageSize,
  sortBy,
}) => {
  let url = Urls.getApiUrl(
    `admin/${getAccountId()}/system/${programId}?page_no=${pageNo}&page_size=${pageSize}&sort_by=${sortBy}`,
    MICROSERVICES.ENROLLMENTMANAGER,
  )
  return await service
    .put(url, requestBody)
    .then((data) => data)
    .catch((error) => error)
}

//watcher and worker functions for getProgramMetadataOfCurrentProgram

export function* getProgramEnrollmentMetadataOfProgramWatcher() {
  yield takeLatest(
    GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_REQUEST,
    getProgramEnrollmentMetadataOfProgramWorker,
  )
}

function* getProgramEnrollmentMetadataOfProgramWorker({ payload }) {
  try {
    let response
    response = yield call(getProgramMetadataOfCurrentProgramAPICall, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({
        type: GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_SUCCESS,
        programMetadata: data.data || null,
        message: '',
      })
    } else {
      yield put({
        type: GET_GS_REQUESTS_FAILURE,
        message: 'POST PROGRAM FILE REQUEST ERROR',
      })
    }
  } catch (error) {
    yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
  }
}

//server endpoint api execution function to get all systems as response from server - PUT method
const getProgramMetadataOfCurrentProgramAPICall = async (
  programEnrollmentMetadataId,
) => {
  let url = Urls.getApiUrl(
    `admin/${getAccountId()}/programenrollmentforms/${programEnrollmentMetadataId}`,
    MICROSERVICES.PROGRAMMANAGER,
  )
  return await service
    .get(url)
    .then((data) => data)
    .catch((error) => error)
}

//watcher and worker functions for deleteProgramFile

export function* deleteProgramFileWatcher() {
  yield takeLatest(DELETE_FILE_REQUEST, deleteProgramFileWorker)
}

function* deleteProgramFileWorker({ payload }) {
  try {
    let response
    response = yield call(deleteProgramFileAPICall, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({
        type: DELETE_FILE_SUCCESS,
        programMetadata: data.data || null,
        message: '',
      })
    } else {
      yield put({
        type: GET_GS_REQUESTS_FAILURE,
        message: 'DELETE PROGRAM FILE REQUEST ERROR',
      })
    }
  } catch (error) {
    yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
  }
}

//server endpoint api execution function to get all systems as response from server - PUT method
const deleteProgramFileAPICall = async ({
  programEnrollmentMetadataId,
  program_file_key,
}) => {
  let url = Urls.getApiUrl(
    `admin/${getAccountId()}/programenrollmentforms/${programEnrollmentMetadataId}/programfile/delete`,
    MICROSERVICES.PROGRAMMANAGER,
  )
  url += '?program_file_key=' + program_file_key
  return await service
    .delete(url)
    .then((data) => data)
    .catch((error) => error)
}

//watcher and worker functions for downloadProgramFile

export function* downloadProgramFileWatcher() {
  yield takeLatest(DOWNLOAD_FILE_REQUEST, downloadProgramFileWorker)
}

function* downloadProgramFileWorker({ payload }) {
  try {
    let response
    response = yield call(downloadProgramFileAPICall, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({
        type: DOWNLOAD_FILE_SUCCESS,
        programFileDownloadLink: data.data || null,
        message: '',
      })
    } else {
      yield put({
        type: GET_GS_REQUESTS_FAILURE,
        message: 'DOWNLOAD PROGRAM FILE REQUEST ERROR',
      })
    }
  } catch (error) {
    yield put({ type: GET_GS_REQUESTS_FAILURE, message: error })
  }
}

//server endpoint api execution function to get all systems as response from server - PUT method
const downloadProgramFileAPICall = async ({
  programEnrollmentMetadataId,
  program_file_key,
}) => {
  let url = Urls.getApiUrl(
    `admin/${getAccountId()}/programenrollmentforms/${programEnrollmentMetadataId}/programfile/download`,
    MICROSERVICES.PROGRAMMANAGER,
  )
  url += '?program_file_key=' + program_file_key
  return await service
    .get(url)
    .then((data) => data)
    .catch((error) => error)
}

const getProgramsByIdRequest = async (payload) => {
  const { accountId, programId } = payload
  return await service
    .get(
      Urls.getApiUrl(
        `admin/${accountId}/programs/${programId}`,
        MICROSERVICES.PROGRAMMANAGER,
      )
    )
    .then((programDetails) => programDetails)
    .catch((error) => error)
}


function* getProgramsById({ payload }) {
  try {
    const response = yield call(getProgramsByIdRequest, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({ type: GET_PROGRAM_BY_ID_SUCCESS, payload: data.data })
    } else if (status === 404) {
      yield put({ type: GET_PROGRAM_BY_ID_NOT_FOUND })
    } else {
    }
  } catch (error) {
    console.debug(error)
  }
}

export function* getProgramById() {
  yield takeEvery(GET_PROGRAM_BY_ID, getProgramsById)
}
